var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app-wrapper" } },
    [
      _c("router-view", { key: _vm.lang }),
      _vm.isFloatingShow
        ? _c("button", {
            staticClass: "floating",
            class: [
              { double: _vm.$route.fullPath.includes("community/home") },
              { main: _vm.$route.path === "/main" },
            ],
            on: {
              click: function ($event) {
                return _vm.$router.push({ name: "Landing" })
              },
            },
          })
        : _vm._e(),
      _c(
        "BaseModal",
        {
          attrs: { id: "copy-modal", "no-content": "" },
          on: {
            clickConfirm: function ($event) {
              return _vm.clickCancel("copy-modal")
            },
          },
        },
        [
          _c("template", { slot: "title" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("modal.linkcopy")) + "\n    "),
          ]),
        ],
        2
      ),
      _c(
        "BaseModal",
        {
          attrs: { id: "login-required", "cancel-btn": "" },
          on: {
            clickConfirm: _vm.clickConfirm,
            clickCancel: function ($event) {
              return _vm.clickCancel("login-required")
            },
          },
        },
        [
          _c("template", { slot: "title" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("modal.login.title")) + "\n    "),
          ]),
          _c("template", { slot: "content" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("modal.login.content")) + "\n    "
            ),
          ]),
          _c("template", { slot: "confirm" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("modal.login.confirm")) + "\n    "
            ),
          ]),
        ],
        2
      ),
      _c(
        "BaseModal",
        {
          attrs: { id: "logout", "no-content": "" },
          on: { clickConfirm: _vm.clickLogout },
        },
        [
          _c("template", { slot: "title" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("modal.logout.title")) + "\n    "
            ),
          ]),
        ],
        2
      ),
      _c(
        "BaseModal",
        {
          attrs: { id: "nice-id-check", "cancel-btn": "", "no-content": "" },
          on: {
            clickConfirm: _vm.confirmNiceId,
            clickCancel: function ($event) {
              return _vm.clickCancel("nice-id-check")
            },
          },
        },
        [
          _c("template", { slot: "title" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("modal.nice.title")) + "\n    "),
          ]),
          _c("template", { slot: "confirm" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("modal.nice.confirm")) + "\n    "
            ),
          ]),
        ],
        2
      ),
      _c("ChangeNickName"),
      _vm._m(0),
      _c("NoticeModal", { attrs: { id: "notice-modal", "no-more": "" } }),
      _c("NoticeModal", { attrs: { id: "urgent-modal" } }),
      _vm.omcUpdate
        ? _c(
            "div",
            { staticClass: "night-wrapper", staticStyle: { top: "80px" } },
            [
              _c(
                "div",
                { staticClass: "night" },
                _vm._l(10, function (i) {
                  return _c("div", { key: i, staticClass: "shooting_star" })
                }),
                0
              ),
            ]
          )
        : _vm._e(),
      _vm.showPhoneAuth ? _c("no-phone") : _vm._e(),
      _c("Modal", { ref: "pumpkin-modal", attrs: { id: "pumpkin-modal" } }),
      _c("WinModal"),
      _c("Modal", { ref: "global-error", attrs: { id: "global-error" } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("form", { attrs: { name: "form_chk", method: "post" } }, [
      _c("input", {
        attrs: { type: "hidden", name: "m", value: "checkplusService" },
      }),
      _c("input", { attrs: { type: "hidden", name: "EncodeData" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }